import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-desktop-message',
  imports: [
    CommonModule
  ],
  templateUrl: './desktop-message.component.html',
  styleUrl: './desktop-message.component.css'
})
export class DesktopMessageComponent implements OnInit {

  consultor = signal<any>(null);
  urlShared = environment.serverUrl;

  constructor() { }

  ngOnInit(): void {
    this.consultor.set(
      {
        name: localStorage.getItem('consultorName'),
        email: localStorage.getItem('consultorEmail'),
        url: `${this.urlShared}/consultor/${localStorage.getItem('consultor')}`,
        qr: localStorage.getItem('qr')
      }
    )
  }


}
